import { render, staticRenderFns } from "./ArticleComponent.vue?vue&type=template&id=7573b31e&"
import script from "./ArticleComponent.vue?vue&type=script&lang=ts&"
export * from "./ArticleComponent.vue?vue&type=script&lang=ts&"
import style0 from "./ArticleComponent.vue?vue&type=style&index=0&id=7573b31e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports